/**
 * Optical-centering nudge for serif day numbers in date pills.
 *
 * Cormorant Garamond uses OLDSTYLE (text) figures, which sit at different
 * vertical positions rather than all aligning to the cap height:
 *   • 6, 8           ascend above x-height
 *   • 3, 4, 5, 7, 9  descend below the baseline
 *   • 0, 1, 2        sit at x-height (no ascender/descender)
 *
 * Because the glyphs are centered by their line box (baseline-relative), a
 * descender or x-height number visually sits low in the pill while an ascender
 * number reads as centered. This returns a small `translateY` value (em units,
 * so it scales with font-size) that lifts the low-sitting numbers so every date
 * reads as optically centered between the weekday and month labels.
 *
 * Values are empirical — tune here and both date scrollers (Itinerary +
 * DestinationScheduler) update together.
 */
export function figureNudge(num: string): string {
  const asc = /[68]/.test(num);
  const desc = /[34579]/.test(num);
  if (asc && desc) return '-0.05em';  // spans full height (e.g. 36, 38) — nearly centered
  if (asc) return '0em';              // ascender only (6, 8, 16, 26) — already reads centered
  if (desc) return '-0.13em';         // descender only (7, 27) — sits lowest, lift most
  return '-0.07em';                   // x-height only (1, 2, 10, 11, 12, 20, 21, 22)
}
